import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Header from '../../components/Header';
import { LegalNotices } from '../../components/LegalNotices';
import { Subscores } from '../../components/charts/Subscores';
import styled from 'styled-components';
import { PlanImpactApp, PlanImpactAppSmall } from '../../components/charts/PlanImpact';
import { scoreCardCopy } from '../../components/charts/scoreConstants';
import { LoadingBar } from '../../components/util/LoadingBar';
import { runFullSimulation } from '../../actions/simulationActions';
import { fetchSpendingPlan } from '../../actions/wealthManagementActions';
import { fetchJobsModule } from '../../actions/jobsActions';
import { withRegistrationDialog } from '../../components/RegistrationDialog';

import { Fab } from 'rmwc/Fab';
import { Select } from 'rmwc/Select';

import { Typography } from 'rmwc/Typography';
import { ContactFooterFloat, ContactFooterShim } from '../../components/Footer';
import { kebabToCamelCase } from '../../helpers/stringHelper';
import { wlPath, wlVar } from '../../helpers/whitelabel';
import { isTest } from '../../helpers/environment';
import {
  media,
  screenSizes,
  Container,
  StyledContainer,
  containerCss,
  headerHeightWide,
  headerHeightNarrow,
} from '../../helpers/styleConstants';

const FadingBottomOverImage = styled.div`
  position: absolute;
  z-index: 0;
  bottom: 0;
  right: 0;
  left: 0;
  height: 60%;
  background: none;
  background: -moz-linear-gradient(top, rgba(250, 250, 250, 0) 0%, rgba(250, 250, 250, 1) 80%);
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0%, rgba(250, 250, 250, 0)),
    color-stop(80%, rgba(250, 250, 250, 1))
  );
  background: -webkit-linear-gradient(top, rgba(250, 250, 250, 0) 0%, rgba(250, 250, 250, 1) 80%);
  background: -o-linear-gradient(top, rgba(250, 250, 250, 0) 0%, rgba(250, 250, 250, 1) 80%);
  background: -ms-linear-gradient(top, rgba(250, 250, 250, 0) 0%, rgba(250, 250, 250, 1) 80%);
  background: linear-gradient(to bottom, rgba(250, 250, 250, 0) 0%, rgba(250, 250, 250, 1) 80%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00fafafa', endColorstr='#fafafa', GradientType=0);
`;

const ShadeOverImage = styled.div`
  position: absolute;
  z-index: 0;
  bottom: 0;
  right: 0;
  left: 0;
  height: 100%;
  background: rgba(0, 0, 0, 0.35);
`;

const MainBody = styled.div`
  margin: 0 15px;
  ${media.tabletLandscapeUp`
    margin-left: 0px;
  `};
`;

export class Frame extends Component {
  constructor(props) {
    super(props);
    this.state = {
      howDialogOpen: false,
      fixedScore: false,
      screenWidth: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
      screenHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions);
    if (!this.props.results) {
      this.props.runFullSimulation();
    }
    if (!this.props.spendingPlan) {
      this.props.fetchSpendingPlan();
    }
    if (!this.props.jobs) {
      this.props.fetchJobsModule();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () => {
    this.setState({
      screenWidth: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
      screenHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
    });
  };

  handleScroll = () => {
    const actionPlan = document.getElementById('content-action-plan');
    let top = headerHeightWide;

    // sometimes the element hasn't loaded yet
    if (actionPlan) {
      const rect = actionPlan.getBoundingClientRect();
      top = rect.top;
    }

    if (top < headerHeightWide && !this.state.fixedScore) {
      this.setState({ fixedScore: true });
    } else if (top >= headerHeightWide && this.state.fixedScore) {
      this.setState({ fixedScore: false });
    }
  };

  render() {
    const { match, dashboard, children, results, spendingPlan, updatedResults, jobs, contentPages, ui } = this.props;

    if (!dashboard || !results || !spendingPlan || !jobs || !contentPages) {
      return <LoadingBar />;
    }

    const startHealth = Math.min(results.scores.readiness_grade, 1);

    const totalGained = contentPages
      .filter(item => !dashboard.removed_steps.includes(item.type))
      .reduce((acc, item) => acc + item.gain, 0);

    const totalHealth = Math.min(results.scores.target_readiness_grade, 1);

    let singleGained;
    let singleHealth;
    let singleLabel;
    if (match.url != '/start/plan-intro' && this.props.tools.active) {
      singleGained = this.props.tools.dollarsGained;
      singleHealth = startHealth + (totalHealth - startHealth) * singleGained / totalGained;
      singleLabel = this.props.tools.active;
    }

    return (
      <div style={{ height: '100%' }}>
        <Header fixed showSignIn={true} />
        {this.state.screenWidth >= 750 ? (
          <Fragment>
            <div
              style={{
                height: '600px',
                position: 'relative',
                backgroundImage: `url(${require(`images/${ui.frameBackgroundImage}`)})`,
                backgroundSize: 'cover',
                backgroundPosition: '50% 50%',
                zIndex: '-1',
              }}
            >
              <ShadeOverImage />
              <FadingBottomOverImage />
            </div>
            <div
              style={{
                width: this.state.screenWidth >= screenSizes.tabletLandscapeUp ? '80%' : '92%',
                marginLeft: 'auto',
                marginRight: 'auto',
                marginTop: this.state.screenWidth >= screenSizes.tabletLandscapeUp ? '-500px' : '-550px',
                position: 'relative',
                zIndex: '0',
                minHeight: '100%',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Typography
                  use={this.state.screenWidth >= screenSizes.tabletLandscapeUp ? 'headline3' : 'headline5'}
                  tag="div"
                  style={{ color: 'rgba(255,255,255,0.87', textAlign: 'center' }}
                >
                  <strong>{ui.frameTitle}</strong>
                </Typography>
              </div>
              <div
                className="mt-2"
                style={{
                  width: '100%',
                  backgroundColor: 'white',
                  display: 'flex',
                  alignItems: 'stretch',
                  minHeight: 'calc(100vh - 222px)',
                }}
              >
                <div style={{ width: '250px', borderRight: '1px solid #ccc' }}>
                  <div style={{ width: '250px' }} />
                  <div
                    id="score-left"
                    style={{
                      ...(this.state.fixedScore
                        ? {
                            position: 'fixed',
                            top: `${headerHeightWide}px`,
                            left: this.state.screenWidth >= screenSizes.tabletLandscapeUp ? '10%' : '4%',
                          }
                        : { paddingLeft: '1px' }),
                    }}
                  >
                    <Typography className="pt-1" use="body1" tag="div" style={{ textAlign: 'center' }}>
                      <strong>Financial Health Score</strong>
                    </Typography>
                    <PlanImpactApp
                      healthCurrent={startHealth * 100}
                      healthSingle={singleHealth && singleHealth * 100}
                      dollarsGainedSingle={singleGained}
                      activeLabel={singleLabel}
                      healthTotal={totalHealth * 100}
                      dollarsGainedTotal={totalGained}
                      showHow
                      scores={results.scores}
                      small
                    />
                  </div>
                </div>
                <div id="content-action-plan" style={{ width: 'calc(100% - 250px)', marginLeft: '15px' }}>
                  <MainBody>
                    {children}
                    <ContactFooterShim />
                  </MainBody>
                </div>
              </div>
            </div>
          </Fragment>
        ) : (
          <div style={{ width: '100%' }}>
            {/* shim */}
            <div style={{ height: '100px' }} />
            <div
              style={{
                position: 'fixed',
                top:
                  this.state.screenWidth >= screenSizes.tabletPortraitUp
                    ? `${headerHeightWide}px`
                    : `${headerHeightNarrow}px`,
                width: '100%',
                zIndex: 1,
              }}
            >
              <PlanImpactAppSmall
                healthCurrent={startHealth * 100}
                healthSingle={singleHealth && singleHealth * 100}
                dollarsGainedSingle={singleGained}
                activeLabel={singleLabel}
                healthTotal={totalHealth * 100}
                dollarsGainedTotal={totalGained}
                showHow
                scores={results.scores}
                small
              />
            </div>
            <div
              style={{
                height: this.state.screenHeight * 0.4,
                position: 'relative',
                backgroundImage: `url(${require(`images/${ui.frameBackgroundImage}`)})`,
                backgroundSize: 'cover',
                backgroundPosition: '50% 50%',
                zIndex: '-1',
              }}
            >
              <ShadeOverImage />
              <FadingBottomOverImage />
            </div>
            <div
              style={{
                width: '100%',
                marginTop: '-70px',
                position: 'relative',
                zIndex: '0',
                minHeight: '100%',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'column',
                }}
              >
                <Typography
                  use={this.state.screenWidth >= screenSizes.tabletLandscapeUp ? 'headline3' : 'headline5'}
                  tag="div"
                  style={{ color: 'black', textAlign: 'center' }}
                >
                  <strong>{ui.frameTitle}</strong>
                </Typography>
                <MainBody>
                  {children}
                  <ContactFooterShim />
                </MainBody>
              </div>
            </div>
          </div>
        )}
        <ContactFooterFloat />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
    dashboard: state.modules.dashboard.data,
    results: state.simulations.results,
    spendingPlan: state.modules.spendingPlan.data,
    jobs: state.modules.jobs.data,
    state: state,
    updatedResults: state.modules.dashboard.simulation ? state.modules.dashboard.simulation.results : null,
    tools: state.tools,
    contentPages: state.contentPages.data,
    ui: state.ui,
  };
}

export default connect(mapStateToProps, { runFullSimulation, fetchSpendingPlan, fetchJobsModule })(Frame);
